import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { semanticColors } from '../common/styles/colorTokens';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Container>
      <Content>
        <IllustrationWrapper>
          <img 
            src="https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif" 
            alt="404 animation"
          />
        </IllustrationWrapper>
        <ErrorWrapper>
          <ErrorCode>404</ErrorCode>
          <ErrorMessage>페이지를 찾을 수 없습니다</ErrorMessage>
          <Description>
            요청하신 페이지가 삭제되었거나 일시적으로 사용할 수 없습니다.
          </Description>
        </ErrorWrapper>
        <ButtonGroup>
          <Button onClick={handleGoBack} $primary>
            <ButtonIcon>←</ButtonIcon>
            돌아가기
          </Button>
          <Button onClick={handleRefresh}>
            <ButtonIcon>↻</ButtonIcon>
            새로고침
          </Button>
        </ButtonGroup>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, ${semanticColors.background.primary} 0%, ${semanticColors.background.secondary} 100%);
`;

const Content = styled.div`
  text-align: center;
  padding: 2rem;
  max-width: 600px;
  width: 100%;
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
`;

const IllustrationWrapper = styled.div`
  margin-bottom: 2rem;
  
  img {
    width: 100%;
    max-width: 400px;
    height: auto;
    border-radius: 12px;
  }
`;

const ErrorWrapper = styled.div`
  margin-bottom: 2rem;
`;

const ErrorCode = styled.h1`
  font-size: 4.5rem;
  font-weight: 800;
  background: linear-gradient(135deg, ${semanticColors.background.brand} 0%, ${semanticColors.background.brandHover} 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
  line-height: 1;
`;

const ErrorMessage = styled.h2`
  font-size: 2rem;
  color: #495057;
  margin: 1rem 0;
  font-weight: 600;
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: #868e96;
  margin: 0.5rem 0;
  line-height: 1.6;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
`;

const ButtonIcon = styled.span`
  margin-right: 8px;
  font-size: 1.2rem;
`;

const Button = styled.button<{ $primary?: boolean }>`
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 12px;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  transition: all 0.2s ease;
  
  ${props => props.$primary ? `
    background: linear-gradient(135deg, #228be6 0%, #15aabf 100%);
    color: white;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(34, 139, 230, 0.3);
    }
  ` : `
    background: ${semanticColors.background.primary};
    color: ${semanticColors.text.primary};
    
    &:hover {
      background: ${semanticColors.background.primaryHover};
      transform: translateY(-2px);
    }
  `}
  
  &:active {
    transform: translateY(0);
  }
`;

export default NotFound; 